import { render, staticRenderFns } from "./OnofficeActivation.vue?vue&type=template&id=4e77ddc6&"
import script from "./OnofficeActivation.vue?vue&type=script&lang=js&"
export * from "./OnofficeActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports